import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
import { requestFailed, requestStarted, requestSucceeded } from "../../slices/manage/shopSpecialPrice.slice";
var authHeaders = function() {
    return {
        Authorization: "Bearer ".concat(localStorage.getItem("accessToken"))
    };
};
var responseData = function(response) {
    var _response_data;
    var _response_data_data, _ref;
    return (_ref = (_response_data_data = response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data) !== null && _response_data_data !== void 0 ? _response_data_data : response === null || response === void 0 ? void 0 : response.data) !== null && _ref !== void 0 ? _ref : null;
};
var errorMessage = function(error) {
    var _error_response_data, _error_response;
    var message = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message;
    if (Array.isArray(message)) return message.join(", ");
    if (typeof message === "string" && message) return message;
    return "เกิดข้อผิดพลาดหรือเครือข่ายขัดข้อง";
};
var runRequest = function(key, request) {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var data, error, message;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch(requestStarted(key));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            request()
                        ];
                    case 2:
                        data = _state.sent();
                        dispatch(requestSucceeded({
                            key: key,
                            data: data
                        }));
                        return [
                            2,
                            {
                                success: true,
                                data: data
                            }
                        ];
                    case 3:
                        error = _state.sent();
                        message = errorMessage(error);
                        dispatch(requestFailed({
                            key: key,
                            error: message
                        }));
                        return [
                            2,
                            {
                                success: false,
                                error: message
                            }
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var loadShopSpecialPriceFilterOptions = function() {
    return runRequest("filterOptions", /*#__PURE__*/ _async_to_generator(function() {
        var _ref, branchesResponse, saleResponse, brandsResponse;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            http.post(endPoint.GET_SHOP, {
                                searchtext: ""
                            }, {
                                headers: authHeaders()
                            }),
                            http.get(endPoint.SALE, {
                                headers: authHeaders()
                            }),
                            http.get(endPoint.MST_BRANDS, {
                                headers: authHeaders()
                            })
                        ])
                    ];
                case 1:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        3
                    ]), branchesResponse = _ref[0], saleResponse = _ref[1], brandsResponse = _ref[2];
                    return [
                        2,
                        {
                            branches: responseData(branchesResponse) || [],
                            sales: responseData(saleResponse) || [],
                            brands: responseData(brandsResponse) || []
                        }
                    ];
            }
        });
    }));
};
export var loadShopSpecialPriceBranches = function(payload) {
    return runRequest("branches", /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        http.post(endPoint.BRANCH_SPECIAL_PRICE_BRANCHES, payload, {
                            headers: authHeaders()
                        })
                    ];
                case 1:
                    return [
                        2,
                        responseData.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    }));
};
export var loadShopSpecialPriceProducts = function(payload) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "configuredProducts";
    return runRequest(target, /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        http.post(endPoint.BRANCH_SPECIAL_PRICE_PRODUCTS, payload, {
                            headers: authHeaders()
                        })
                    ];
                case 1:
                    return [
                        2,
                        responseData.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    }));
};
export var saveShopSpecialPrice = function(payload) {
    return runRequest("save", /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        http.post(endPoint.BRANCH_SPECIAL_PRICE_SAVE, payload, {
                            headers: authHeaders()
                        })
                    ];
                case 1:
                    return [
                        2,
                        responseData.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    }));
};
